import { useEffect, useState } from "react";
import { getIntegrations } from "../../../api/integrationsApi";

export default function useCrmAvailability() {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    let active = true;
    getIntegrations().then((catalog) => { if (active) setEnabled(catalog.enabled === true); })
      .catch(() => { /* Optional personalization must not block onboarding. */ });
    return () => { active = false; };
  }, []);
  return enabled;
}
